import { useEffect, useRef, useState } from "react"
import { Spin } from "@gogoro/go-design"
import { BoxArrowInUpRight } from "@styled-icons/bootstrap"
import * as pdfjsLib from "pdfjs-dist/webpack.mjs"
import styled from "styled-components"

const PdfContainer = styled.div`
  border: solid 1px rgba(50, 50, 55, 0.1);
  display: flex;
  flex-direction: column;
  ${({ customStyle }) => customStyle};
`
const NewTabButton = styled.div`
  background: rgba(0, 0, 0, 0.75);
  padding: 8px;
  position: absolute;
  right: 0;
  cursor: pointer;
`

const PdfViewer = ({ url, style = {}, fullscreen = false, scale = 1.5, containerRef = null }) => {
  const [pageNumber, setPageNumber] = useState([])
  const [isReady, setIsReady] = useState(false)
  const canvasRefs = useRef([])

  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.scrollTop = 0
    }
  }, [url, containerRef])

  useEffect(() => {
    let isMounted = true
    if (url) {
      pdfjsLib.getDocument(url).promise.then((pdf) => {
        if (isMounted) {
          const numPages = pdf.numPages
          const pages = Array.from({ length: numPages }, (_, index) => index + 1)
          setPageNumber(pages)

          for (let i = 0; i < numPages; i++) {
            pdf.getPage(i + 1).then((page) => {
              const viewport = page.getViewport({ scale: scale })
              let canvas = canvasRefs.current[i]
              if (canvas) {
                const context = canvas.getContext("2d")
                canvas.height = viewport.height
                canvas.width = viewport.width

                const renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                }
                page.render(renderContext)
              }
            })
          }

          setIsReady(true)
        }
      })
    }
    return () => {
      isMounted = false
    }
  }, [url, scale])

  const openFullscreenPDF = () => {
    const newTab = window.open(url, "_blank")
    newTab.onload = () => {
      newTab.document.body.requestFullscreen()
    }
  }

  return (
    <PdfContainer customStyle={style} data-testid="pdf-viewer">
      {fullscreen && (
        <NewTabButton>
          <BoxArrowInUpRight size={24} onClick={openFullscreenPDF} style={{ color: "rgba(255,255,255,0.87)" }} />
        </NewTabButton>
      )}
      {!isReady ? (
        <Spin show style={{ height: "100%" }} />
      ) : (
        pageNumber.map((pageNum, index) => {
          return <canvas style={{ maxWidth: "100%" }} ref={(ref) => (canvasRefs.current[index] = ref)} key={pageNum} />
        })
      )}
    </PdfContainer>
  )
}

export default PdfViewer
